/* eslint-disable jsx-a11y/img-redundant-alt */
import { Row, Table, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  pupSelector,
  storeProductSelector,
  surveySelector,
} from "../../../services/selector/index.";
import {
  IconDetailSurvey,
  IconEdit,
  IconEye,
  IconLock,
  IconNext,
  IconPolygon,
  IconPre,
  IconXmark,
} from "../../../assets/icon";
import "../../../assets/style/table/survey.scss";
import { useEffect, useState } from "react";
import { useMemo } from "react";
import { setOpenPUDelete } from "../../../services/slice/PopUpSlice";
import TranslateText from "../TranslateText";
import { formatPrice } from "../../../utils/functionCommon";
import {
  getLogProduct,
  setPageProduct,
} from "../../../services/slice/StoreSlice";
import { useTranslation } from "react-i18next";
import {
  deleteSurvey,
  getDataStatisticsSurvey,
  getDataSurvey,
  setConfigReportOverview,
  setOpenEditSurvey,
  setStatusSurvey,
  setTypeSurvey,
} from "../../../services/slice/SurveySlice";
import ModalDelete from "../Modal/delete/ModalDelete";
import { useNavigate } from "react-router-dom";
import queryString from "query-string";

const TableSurveyStatistics = () => {
  const dispatch = useDispatch();
  const statePup = useSelector(pupSelector);
  const { dataDelete } = statePup;
  const surveyState = useSelector(surveySelector);
  const { configStatistics, total, dataStatistics } = surveyState;
  const [page, setPage] = useState(0);
  const [isDeleteTbl, setIsDeleteTbl] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getDataStatisticsSurvey(configStatistics));
  }, [configStatistics.search, configStatistics.status]);
  const dataSource = useMemo(() => {
    const result = dataStatistics?.map((item, index) => {
      return {
        ...item,
        object: item.typeSurvey === 1 ? "Toàn bộ KH" : "CCS",
        status:
          item.status === 1
            ? "Chưa diễn ra"
            : item.status === 2
            ? "Đang diễn ra"
            : "Đã kết thúc",
        STT: total > 10 && page >= 2 ? (page - 1) * 10 + index + 1 : index + 1,
        key: item.id,
      };
    });
    return result;
  }, [dataStatistics, total, page]);

  // useEffect(() => {
  //   if (callBackRequest) {
  //     dispatch(
  //       getDataSurvey({
  //         search: "",
  //         status: 0,
  //         typeSurvey: 0,
  //         option: {
  //           limit: 10,
  //           offset: 1,
  //           order: "asc",
  //         },
  //       })
  //     );
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [callBackRequest]);

  const handleShowModalDelete = (value) => {
    setIsDeleteTbl(true);
    dispatch(
      setOpenPUDelete({ stateOpen: true, content: value.name, id: value.id })
    );
  };

  const handleShowEditModal = (value) => {
    dispatch(setOpenEditSurvey({ isOpen: true, id: value.id }));
  };
  const handleShowDetail = (record) => {
    const params = {
      id: record.id,
      typeSurvey: record.typeSurvey,
      typeTime: 0,
      timeStart: "",
      timeEnd: "",
      nameSurvey: record.name,
      keyTab: 1,
    };
    // navigate(`/survey_statistics_detail/id=${id}`)
    navigate(`/survey_statistics_detail?${queryString.stringify(params)}`);
  };

  const columns = [
    {
      title: "STT",
      dataIndex: "STT",
      key: "STT",
      className: "centerCell",
      width: 70,
    },

    {
      title: <TranslateText text="Tên cuộc khảo sát" />,
      dataIndex: "name",
      key: "name",
      className: "title pointer",
      width: 600,
      ellipsis: {
        showTitle: false,
      },
      render: (value) => (
        <Tooltip placement="topLeft" title={value}>
          {value}
        </Tooltip>
      ),
    },
    {
      title: (
        <div className="statusProduct" style={{ minWidth: 100 }}>
          <p className="textStatus">
            <TranslateText text="Số lượt KH đánh giá" />
            <span className="iconChange">
              <IconPolygon />
            </span>
            <ul className="list" style={{ minWidth: "200px" }}>
              <li
                className="item"
                // onClick={() => {
                //   dispatch(setTypeSurvey(0));
                // }}
              >
                Sắp xếp theo thứ tự tăng dần
              </li>
              <li
                className="item"
                // onClick={() => {
                //   dispatch(setTypeSurvey(1));
                // }}
              >
                Sắp xếp theo thứ tự giảm dần
              </li>
            </ul>
          </p>
        </div>
      ),
      dataIndex: "totalReviews",
      key: "totalReviews",
      className: "centerCell",
    },
    {
      title: (
        <div className="statusProduct">
          <p className="textStatus">
            <TranslateText text="Tình trạng" />
            <span className="iconChange">
              <IconPolygon />
            </span>
            <ul className="list" style={{ minWidth: "100px" }}>
              <li
                className="item"
                onClick={() => {
                  dispatch(setStatusSurvey(0));
                }}
              >
                Tất cả
              </li>
              <li
                className="item"
                onClick={() => {
                  dispatch(setStatusSurvey(1));
                }}
              >
                Chưa diễn ra
              </li>
              <li
                className="item"
                onClick={() => {
                  dispatch(setStatusSurvey(2));
                }}
              >
                Đang diễn ra
              </li>
              <li
                className="item"
                onClick={() => {
                  dispatch(setStatusSurvey(3));
                }}
              >
                Kết thúc
              </li>
            </ul>
          </p>
        </div>
      ),
      dataIndex: "status",
      key: "status",
      className: "centerCell",
      render: (text, record) => <span>{text}</span>,
    },

    {
      title: <TranslateText text="Chức năng" />,
      key: "action",
      dataIndex: "action",
      className: "centerCell m10",
      render: (text, record) => {
        return (
          <div
            className="centerCell flex justify-center w-full "
            style={{ minWidth: "120px" }}
          >
            <span
              className="pointer iconTbl"
              onClick={() => {
                handleShowDetail(record);
              }}
            >
              <Tooltip title="Chi tiết">
                <IconDetailSurvey />
              </Tooltip>
            </span>
          </div>
        );
      },
    },
  ];
  // const tableLoading = {
  //   spinning: storeState.isLoading, // isLoading là biến boolean để xác định xem có đang loading hay không
  //   indicator: <IconSpin className="iconSpin" />,
  // };

  const rowClassName = (record) => {
    return record.statusPin ? "marked-row" : "";
  };
  //   const handleDelete = () => {
  //     dispatch(deleteSurvey(dataDelete.id));
  //     setIsDeleteTbl(false);
  //     dispatch(setOpenPUDelete({ stateOpen: false, id: "", content: "" }));
  //   };
  return (
    <>
      {/* {dataDelete.isOpenPUDelete && isDeleteTbl ? (
        <ModalDelete
          handleDelete={handleDelete}
          textDisable="Bạn có đồng ý xóa "
          title="Xóa cuộc khảo sát"
          width={680}
        />
      ) : null} */}
      <Row style={{ width: "100%" }}>
        <Table
          // rowClassName={rowClassName}
          //   loading={tableLoading}
          className="wrapperTblSurvey"
          style={{ width: "100%", marginTop: "2.6rem" }}
          columns={columns}
          dataSource={dataSource}
          pagination={
            total > 10
              ? {
                  onChange: (value) => {
                    setPage(value);
                    dispatch(setPageProduct(value));
                  },
                  total,
                  pageSize: 10,
                  current: configStatistics.option.offset,
                  prevIcon: <IconPre />,
                  nextIcon: <IconNext />,
                  showSizeChanger: false,
                }
              : false
          }
        />
      </Row>
    </>
  );
};

export default TableSurveyStatistics;
